import { IssuerSalesContactDetails } from './../../model/issuer-sales-contact';
import { Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { IssuersService } from '../../services/issuers.service';
import { Contact, ContactTableItem } from '../../model/contact';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { KydUserService } from '../../services/kyd-user.service';
import { KydRequestService } from '../../services/kyd-request.service';
import { Request } from '../../model/request';
import { UsersService } from '../../../services/users.service';
import { DcAlertService } from '../../../ui-kit/dc-alert/dc-alert.service';
import { ModalService } from '../../../ui-kit/dc-modal/modal.service';
import { Issuer } from '../../model/issuer';
import { IssuerContactTableItem, IssuerSalesContact } from '../../model/issuer-sales-contact';
import { TransferService } from '../../services/transfer.service';
import { Subscription } from 'rxjs';
import { UserInfo } from 'src/app/admin/model/user';
import { ActivatedRoute, Router } from '@angular/router';
import { CacheService } from '../../services/cache.service';
import { saveAs } from 'file-saver';
import { unparse } from 'papaparse';
import { Location } from '@angular/common';
@Component({
    selector: 'app-list-issuer-contacts',
    templateUrl: './list-issuer-contacts.component.html',
    styleUrls: ['./list-issuer-contacts.component.scss'],
    standalone: false
})
export class ListIssuerContactsComponent implements OnInit, OnDestroy {
  @ViewChild('actionButtonTemplate', { static: true }) actionButtonTemplate: TemplateRef<any>;
  @ViewChild('issuerNameLinkTemplate', { static: true }) issuerNameLinkTemplate: TemplateRef<any>;
  @ViewChild('issuerContactLinkTemplate', { static: true }) issuerContactLinkTemplate: TemplateRef<any>;

  faEllipsisV = faEllipsisV;

  @ViewChild('searchText') searchText;
  columns;
  rows;
  searchOpen;
  searchTextValue;
  isCleared: boolean = false;
  sortOrder = [
    {
      prop: 'issuer',
      dir: 'asc',
    },
  ];
  messages = {
    emptyMessage: 'No Issuer Contacts found.',
    totalMessage: 'Total',
  };
  currentRow: IssuerSalesContactDetails;
  loading: boolean = true;
  userToReInvite: UserInfo;
  private sub: Subscription = new Subscription();
  users: UserInfo[] = [];
  id: string;
  issuerName: string;
  disableCsvBtn: boolean = false;
  filteredContacts: any[] = [];
  constructor(
    private issuersService: IssuersService,
    private kydUserService: KydUserService,
    private kydRequestService: KydRequestService,
    private usersService: UsersService,
    private dcAlertService: DcAlertService,
    private oldModalService: NgbModal,
    private modalService: ModalService,
    private ngbModalService: NgbModal,
    private transferService: TransferService,
    private cacheService: CacheService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  async ngOnInit(): Promise<void> {
    // this.issuersService.refreshContactsSubject.subscribe(() => {
    //   this.fetchContacts();
    // });
    this.listenForCsvDataUpdates();
    this.columns = [
      {
        name: 'Issuer',
        prop: 'issuer',
        resizeable: false,
        draggable: false,
        flexGrow: 2.5,
        canAutoResize: true,
        maxWidth: 250,
        cellTemplate: this.issuerNameLinkTemplate,
      },
      {
        name: 'Name',
        prop: 'name',
        resizeable: false,
        draggable: false,
        flexGrow: 2,
        canAutoResize: true,
        maxWidth: 200,
      },
      {
        name: 'Email',
        prop: 'email',
        resizeable: false,
        draggable: false,
        flexGrow: 2,
        canAutoResize: true,
        maxWidth: 200,
        cellTemplate: this.issuerContactLinkTemplate,
      },
      {
        name: 'Role',
        prop: 'role',
        resizeable: false,
        draggable: false,
        flexGrow: 1.2,
        canAutoResize: true,
        maxWidth: 120,
      },
      {
        name: 'Salesdesk',
        prop: 'salesdesk',
        resizeable: false,
        draggable: false,
        flexGrow: 3.5,
        canAutoResize: true,
        maxWidth: 350,
        pipe: {
          transform: (desks) => desks.filter((desk) => !!desk).join(', '),
        },
      },
      {
        name: 'Sales Region',
        prop: 'salesregion',
        resizeable: true,
        flexGrow: 2,
        canAutoResize: true,
        maxWidth: 200,
        cellClass: 'distContactCell',

        pipe: {
          transform: (regions) => regions.filter((region) => !!region).join(', '),
        },
      },
      {
        name: 'Status',
        prop: 'userStatus',
        resizeable: false,
        draggable: false,
        flexGrow: 1.5,
        canAutoResize: true,
        maxWidth: 150,
      },
      {
        name: 'Last Login',
        prop: 'lastLogin',
        resizeable: false,
        draggable: false,
        flexGrow: 1.5,
        canAutoResize: true,
        maxWidth: 120,
        cellTemplate: 'dateTimeTemplate',
      },
      {
        name: '',
        prop: 'issuerid',
        resizeable: false,
        draggable: false,
        flexGrow: 1.5,
        canAutoResize: true,
        maxWidth: 150,
        cellTemplate: this.actionButtonTemplate,
        cellClass: 'text-center',
      },
    ];

    if (!this.cacheService.getData().users) {
      this.loading = true;
      try {
        const users = await this.fetchUsers();
        this.cacheService.addData({ users });
        this.users = this.cacheService.getData().users;
        this.loading = false;
      } catch (error) {
        console.log('failed to fetch from cognito', error);
      }
    }

    if (!this.cacheService.getData().issuerContacts) {
      this.loading = true;
      try {
        const issuerContacts = await this.issuersService.getAllIssuerSalesContacts().toPromise();
        this.cacheService.addData({ issuerContacts });
        this.loading = false;
      } catch (error) {
        console.log('error getting contacts!', error);
      }
    }

    this.fetchContacts();

    this.sub.add(
      this.route.params.subscribe((params) => {
        if (params['id']) {
          this.id = params['id'];
          this.searchTextValue = this.id || '';
          this.filteredContacts = this.rows.filter((x) => x.issuerid == this.id);
          this.issuerName = this.filteredContacts.length ? this.filteredContacts[0].issuer : '';
        }
      })
    );

    this.sub.add(
      this.transferService.notifyObservable$.subscribe((res) => {
        // console.log(res, 'obs res');
        if (res.toRefresh && res.keysToRemove!.length) {
          let isThereOtherKeysToRemove: boolean = false;
          res.keysToRemove.forEach(async (key) => {
            this.cacheService.removeEntry(key);
            if (key === 'issuerContacts') {
              const issuerContacts = await this.issuersService.getAllIssuerSalesContacts().toPromise();
              this.cacheService.addData({ issuerContacts });
            } else if (key === 'users') {
              const users = await this.fetchUsers();
              this.cacheService.addData({ users });
              this.users = this.cacheService.getData().users;
            } else {
              isThereOtherKeysToRemove = true;
            }
          });
          this.fetchContacts();
          isThereOtherKeysToRemove
            ? this.transferService.notifyOther({
                toRefresh: true,
                keysToRemove: res.kesToRemove.filter((x) => x !== 'issuerContacts' && x !== 'users'),
              })
            : this.transferService.completeNotice();
        }
      })
    );

    // if (this.transferService.isClicked) {
    //   this.transferService.childInitCompleteSubject.subscribe(() => {
    //     this.rows = [...this.rows];
    //     if (typeof this.transferService.getData() === 'string') {
    //       this.searchTextValue = this.transferService.getData() || '';
    //     }
    //     this.transferService.isClicked = false;
    //   });
    // }
  }

  async fetchUsers(x?: number): Promise<any> {
    const limit: number = x ? x : 15;
    let count: number = 0;
    while (true && count < limit) {
      try {
        const users: any[] = (await this.usersService.users().toPromise()).filter((user) => user.enabled);
        if (users && users.length > 0 && users[0].status) {
          // console.log(users, 'users returned successfully');
          count++;
          return users;
        } else {
          // Keep waiting
          count++;
          await new Promise((resolve) => setTimeout(resolve, 2000));
        }
      } catch (error) {
        console.error(error);
        // Keep waiting
        count++;
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
    }
  }

  fetchContacts() {
    this.loading = true;
    this.issuersService.getAllIssuerContactsForTable().subscribe((issuerContacts: IssuerContactTableItem[]) => {
      Promise.all(
        issuerContacts.map((x) => {
          if (x.cognitoUserId) {
            this.usersService
              .getLastLogin(x.cognitoUserId)
              .toPromise()
              .then((y) => {
                if (y) {
                  x.lastLogin = y;
                  this.usersService.editUserLoginStamp(x.cognitoUserId, y);
                }
              })
              .then(() => {
                this.usersService
                  .getUserStatusFromCognitoPool(x.cognitoUserId)
                  .toPromise()
                  .then((status) => {
                    if (status) {
                      const mappedStatus = this.usersService.mapStatus(x, status);
                      if (mappedStatus !== x.userStatus) {
                        this.usersService.patchUserStatus(x.cognitoUserId, status).then(() => {
                          x.userStatus = mappedStatus;
                          this.cacheService.removeEntry('users');
                        });
                      }
                    }
                  })
                  .then(() => delete x.cognitoUserId);
              })
              .catch((err) => console.log(err));
          } else {
            x.lastLogin = null;
            delete x.cognitoUserId;
          }
        })
      )
        .then(() => {
          setTimeout(
            () =>
              this.dcAlertService.showAlert({
                type: 'success',
                message: 'User accounts synchronization completed.',
              }),
            2000
          );
        })
        .catch((error) => {
          this.dcAlertService.showAlert({
            type: 'danger',
            message: 'Error synchronizing user accounts!',
          });
        });

      this.rows = issuerContacts.filter((x) => x.id !== '00000000-0000-0000-0000-000000000000'); // exclude admin
      this.loading = false;
    });
  }

  openAddContactModal(content) {
    this.transferService.isClicked = true;
    if (this.isCleared) {
      this.transferService.clearData();
    } else {
      this.transferService.setData(this.id);
    }

    const modalRef = this.oldModalService.open(content, {
      scrollable: false,
      windowClass: 'addRequestModal',
      size: 'lg',
      centered: true,
      // keyboard: false,
      backdrop: 'static',
    });
    modalRef.result.then((result) => {}).catch((error) => {});
  }

  async openInviteModal(row: IssuerContactTableItem) {
    if (!this.isIssuerAlreadyInvited(row)) {
      this.modalService
        .openDialog({
          title: 'INVITE USER TO PLATFORM',
          body: `
            Adding a user to the platform is an irreversible step which will send out the invite email.
          `,
          buttons: {
            negative: 'Cancel',
            positive: 'Invite',
          },
          size: 'md',
        })
        .then(
          async (res) => {
            if (res === '{"positive":1}') {
              await this.inviteUserToPlatform(row);
              this.transferService.notifyOther({ toRefresh: true, keysToRemove: ['issuerContacts', 'users'] });
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  refreshPage() {
    this.transferService.notifyOther({ toRefresh: true, keysToRemove: ['issuerContacts', 'users'] });
  }

  async openReinviteModal(row: IssuerContactTableItem) {
    if (this.isIssuerAlreadyInvited(row)) {
      // console.log(row);
      this.modalService
        .openDialog({
          title: 'RE-SEND INVITATION',
          body: `
          Warning: Re-sending an invitation will first delete the selected user, re-create it, then re-send an invitation email.
          (You can also use this to reset password.)
          `,
          buttons: {
            negative: 'Cancel',
            positive: 'ReInvite',
          },
          size: 'md',
        })
        .then(
          async (res) => {
            if (res === '{"positive":1}') {
              await this.reInviteUserToPlatform(row);
              this.transferService.notifyOther({ toRefresh: true, keysToRemove: ['issuerContacts', 'users'] });
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  async reInviteUserToPlatform(row: IssuerContactTableItem) {
    // load cognito users list
    this.loading = true;

    await this.fetchUsers(10)
      .then(async (users) => {
        this.users = users || [];

        // matching email to find cognito user id and details
        this.userToReInvite = this.users.filter((user) => {
          return user.email === row.email;
        })[0];
        // console.log(this.userToReInvite);

        // delete cognito user
        // console.log(this.userToReInvite.account, this.userToReInvite.id);

        await this.usersService
          .deleteUser(this.userToReInvite.account, this.userToReInvite.id)
          .toPromise()
          .then(async () => {
            await this.usersService.deleteUserInCache(this.userToReInvite.id);
          })
          .then(async () => {
            console.log('step 1');

            // set invited-at status as null, so if failed in step 4 the flag will be correct and can use normal invite to continue
            await this.issuersService
              .setIssuerSalesContactToNotInvited(row.id)
              .toPromise()
              .then(async () => {
                console.log('step 2');

                // make sure set to null as the above set to not invited is not used directly in sendInviteEmail function
                row.invitesentat = null;

                console.log('step 3');

                if (await this.kydUserService.sendIssuerInviteEmail(row, row.issuerid)) {
                  console.log('step 4');
                  // then set new invited-at timestamp
                  await this.issuersService
                    .setIssuerSalesContactToInvited(row.id)
                    .toPromise()
                    .then(() => {
                      this.dcAlertService.showAlert({
                        type: 'success',
                        message: 'User re-invited successfully',
                      });
                      setTimeout(() => {
                        this.fetchContacts();
                      }, 2000);
                    })
                    .catch((e) => {
                      this.loading = false;
                      console.log(e);
                      this.dcAlertService.showAlert({
                        type: 'danger',
                        message: 'Error setting invited flag to TRUE',
                      });
                    });
                } else {
                  await this.fetchUsers(10).then(async (users) => {
                    const isReCreated = users.find((x) => x.email === row.email);

                    if (isReCreated) {
                      const currentContact = await this.issuersService.getIssuerSalesContact(row.id).toPromise();
                      if (currentContact.invitesentat) {
                        this.dcAlertService.showAlert({
                          type: 'success',
                          message: 'User re-invited successfully',
                        });
                      } else {
                        await this.issuersService
                          .setIssuerSalesContactToInvited(row.id)
                          .toPromise()
                          .then(() => {
                            this.dcAlertService.showAlert({
                              type: 'success',
                              message: 'User re-invited successfully',
                            });
                            setTimeout(() => {
                              this.fetchContacts();
                            }, 2000);
                          })
                          .catch((e) => {
                            this.loading = false;
                            console.log(e);
                            this.dcAlertService.showAlert({
                              type: 'danger',
                              message: 'Error setting invited flag to TRUE',
                            });
                          });
                      }
                    } else {
                      this.dcAlertService.showAlert({
                        type: 'danger',
                        message: 'Error re-inviting user in cognito!',
                      });
                    }
                  });
                }
              })
              .catch((e) => {
                this.loading = false;
                console.log(e);
                this.dcAlertService.showAlert({
                  type: 'danger',
                  message: 'Error setting invited flag to FALSE',
                });
              });
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.dcAlertService.showAlert({
              type: 'danger',
              message: 'Error deleting user (step 1 of reinvite), please try "Delete" then "Invite" instead',
            });
          });
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
        this.dcAlertService.showAlert({
          type: 'danger',
          message: 'Error fetching users',
        });
      });
  }

  async inviteUserToPlatform(row: IssuerContactTableItem) {
    this.loading = true;
    if (await this.kydUserService.sendIssuerInviteEmail(row, row.issuerid)) {
      await this.issuersService
        .setIssuerSalesContactToInvited(row.id)
        .toPromise()
        .then(() => {
          this.dcAlertService.showAlert({
            type: 'success',
            message: `User created and invite sent`,
          });
          this.loading = false;
        });
    } else {
      this.dcAlertService.showAlert({
        type: 'danger',
        message: `Failed to add user to platform`,
      });
      this.loading = false;
    }
  }

  tableAction(e) {}

  tableActivate(e) {}

  isIssuerAlreadyInvited(row: IssuerContactTableItem) {
    return row?.invitesentat;
  }

  updateFilter(e) {
    this.rows = [...this.rows];
    this.searchTextValue = e.target.value;
    if (this.searchTextValue == '') {
      this.isCleared = true;
      this.issuerName = null;
      this.location.replaceState('/issuers/contacts');
    }
  }

  editContactModal(content, row) {
    this.currentRow = row;
    this.transferService.setData(row);
    const modalRef = this.ngbModalService.open(content, {
      scrollable: false,
      size: 'lg',
      centered: true,
      // keyboard: false,
      backdrop: 'static',
    });
    modalRef.result
      .then((result) => {
        console.log(row);
      })
      .catch((error) => {});
  }

  async openDeleteModal(row: ContactTableItem) {
    // console.log(row);
    this.modalService
      .openDialog({
        title: 'DELETE CONTACT',
        body: `
          Warning: This will permanently delete the contact and its account from the platform.
          `,
        buttons: {
          negative: 'Cancel',
          positive: 'Delete',
        },
        size: 'md',
      })
      .then(
        async (res) => {
          if (res === '{"positive":1}') {
            await this.deleteIssuerContact(row);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  async deleteIssuerContact(row: ContactTableItem) {
    // console.log(row);

    await this.issuersService
      .deleteContact(row.id)
      .toPromise()
      .then(async (res) => {
        await this.fetchUsers(10)
          .then(async (users) => {
            this.users = users || [];

            const userToDelete =
              this.users.find((user) => {
                return user.email === row.email;
              }) || null;

            if (userToDelete) {
              console.log(userToDelete.account, userToDelete.id);
              await this.usersService
                .deleteUser(userToDelete.account, userToDelete.id)
                .toPromise()
                .then(async () => {
                  await this.usersService.deleteUserInCache(userToDelete.id);
                })
                .then(() => {
                  this.dcAlertService.showAlert({
                    type: 'success',
                    message: 'Contact deleted successfully',
                  });
                  //before reloading, store current search string into transfer service
                  this.transferService.isClicked = true;
                  if (this.searchTextValue) {
                    this.transferService.setData(this.searchTextValue);
                  }
                })
                .catch((error) => {
                  console.log(error);
                  this.dcAlertService.showAlert({
                    type: 'danger',
                    message: 'Error deleting contact in cognito!',
                  });
                })
                .finally(() =>
                  this.transferService.notifyOther({ toRefresh: true, keysToRemove: ['issuerContacts', 'users'] })
                );
            } else {
              // only delete contact in db if it is not invited into cognito
              this.dcAlertService.showAlert({
                type: 'success',
                message: 'Contact deleted successfully',
              });
              //before reloading, store current search string into transfer service
              this.transferService.isClicked = true;
              if (this.searchTextValue) {
                this.transferService.setData(this.searchTextValue);
              }
              this.transferService.notifyOther({ toRefresh: true, keysToRemove: ['issuerContacts'] });
            }
          })
          .catch((err) => {
            console.log('ERROR: ', err);
            this.dcAlertService.showAlert({
              type: 'danger',
              message: 'Error fetching user cognito data',
            });
          });
      })
      .catch((error) => {
        console.log('ERROR: ', error);
        this.dcAlertService.showAlert({
          type: 'danger',
          message: 'Error deleting contact in database table.',
        });
      });
  }

  downloadCSV(title?) {
    // let fields = this.buildHeaders();
    // let rows = this.buildRows();
    let config = {
      header: true,
      skipEmptyLines: false,
    };
    let data = this.id ? this.filteredContacts : this.rows;
    if (data) {
      const csv = unparse(data, [, config]);
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      saveAs(
        blob,
        this.issuerName
          ? this.issuerName.replace(/[.,\s]/g, '_') + '_Contacts'
          : 'Issuer_Contacts' + '-' + new Date(Date.now()).toISOString().split('.')[0]
      );
      this.issuersService.setDownloadCsvSubject('downloadCsvRequestComplete');
    }
  }

  downloadCsvRequest(value: boolean): void {
    if (value === true && !this.disableCsvBtn) {
      this.disableCsvBtn = true;
      this.issuersService.setDownloadCsvSubject('downloadCsvRequest');
    }
  }

  listenForCsvDataUpdates(): void {
    this.sub.add(
      this.issuersService.csvDownloadObservable$.subscribe((data) => {
        console.log(data);
        if (typeof data == 'string' && data == 'downloadCsvRequest') {
          this.downloadCSV('Distributor-Contacts');
        }
        if (typeof data == 'string' && data == 'downloadCsvRequestComplete') {
          this.disableCsvBtn = false;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.loading = false;
    this.users = [];
    this.sub.unsubscribe();
  }
}
